import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumDayOfWeek implements BaseEnumType {
  private static allValues: EnumDayOfWeek[] = []; // make sure this is top-most
  
  public static none = new EnumDayOfWeek(0, "None", "enum_day_of_week_none");
  public static monday = new EnumDayOfWeek(1, "Monday", "enum_day_of_week_monday");
  public static tuesday = new EnumDayOfWeek(2, "Tuesday", "enum_day_of_week_tuesday");
  public static wednesday = new EnumDayOfWeek(3, "Wednesday", "enum_day_of_week_wednesday");
  public static thursday = new EnumDayOfWeek(4, "Thursday", "enum_day_of_week_thursday");
  public static friday = new EnumDayOfWeek(5, "Friday", "enum_day_of_week_friday");
  public static saturday = new EnumDayOfWeek(6, "Saturday", "enum_day_of_week_saturday");
  public static sunday = new EnumDayOfWeek(7, "Sunday", "enum_day_of_week_sunday");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumDayOfWeek.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumDayOfWeek.none; }
  public isMonday() { return this === EnumDayOfWeek.monday; }
  public isTuesday() { return this === EnumDayOfWeek.tuesday; }
  public isWednesday() { return this === EnumDayOfWeek.wednesday; }
  public isThursday() { return this === EnumDayOfWeek.thursday; }
  public isFriday() { return this === EnumDayOfWeek.friday; }
  public isSaturday() { return this === EnumDayOfWeek.saturday; }
  public isSunday() { return this === EnumDayOfWeek.sunday; }

  public static getValues(): readonly EnumDayOfWeek[] {
    return EnumDayOfWeek.allValues;
  }

  public static getValuesExcept0(): readonly EnumDayOfWeek[] {
    return EnumDayOfWeek.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumDayOfWeek {
    const found = EnumDayOfWeek.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumDayOfWeek - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumDayOfWeek): EnumDayOfWeek {
    const found = name ? EnumDayOfWeek.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumDayOfWeek - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumDayOfWeek>): boolean {
    return this.key === other?.key;
  }
}